module.exports = __webpack_public_path__ + "static/nine-industry-innovation.2b6a640c.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/2022/photos/a-propos/sdgs/nine-industry-innovation.png
// module id = 927
// module chunks = 3